import { render, staticRenderFns } from "./Scientific.vue?vue&type=template&id=75246d68&"
import script from "./Scientific.vue?vue&type=script&lang=ts&"
export * from "./Scientific.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports